document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.js-accordion-toggle');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();

    var submenu = toggle.nextElementSibling;
    if (!submenu || !submenu.classList.contains('header-mega-menu__accordion-submenu')) return;

    var isOpen = submenu.classList.contains('is-open');

    // Close all open submenus
    document.querySelectorAll('.header-mega-menu__accordion-submenu.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.previousElementSibling.setAttribute('aria-expanded', 'false');
    });

    // Open this one if it was closed
    if (!isOpen) {
      submenu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
});